import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../../assets/css/authenticationStyles.css';
import {
  clearAll
} from "../../../config/redux/slice/authSlice";
import { appUrls } from '../../../utils/urls/appUrls';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function PasswordResetSuccess() {
  const dispatch = useDispatch()
 
  useEffect(()=>{
      dispatch(clearAll({}))
    }, [])  


  return (
    <AuthFormWrapper sub_text={'Password Reset Successful'} icon="mdi mdi-checkbox-marked-circle" iconColor="text-success">
       <div className='text-center mb-5' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>You have successfully reset your password. 
            You can now login with your new password.</p>
        </div>
      <div className="col-md-12">


        <button type="button" className="btn btn-outline-primary mb-4">
            <i className=" mdi mdi-arrow-left-thick mr-1"></i>
            <Link className='text-hover-white' to={appUrls.login}>Proceed to Login</Link>
        </button>
        {/* <Spinner/> */}
      </div>
    </AuthFormWrapper>
  )
}
